<template>
  <div class="menu-products">
    <div class="container-fluid p-0 h-100 fondo-color-01" id="menu">
      <div class="menu-box p-4 text-center text-white">
        <img src="../assets/img/compadre-01.png" class="personaje-01">

        <div class="carrito-sticky">
          <div class="carrito-sticky__bar">
            <span class="carrito-sticky__label">Carrito</span>
            <span class="carrito-sticky__total">${{ total }}</span>
            <button class="btn btn-outline-light btn-sm" @click="mostrarDetalle = !mostrarDetalle">
              {{ mostrarDetalle ? 'Ocultar' : 'Ver detalle' }}
              <span v-if="carritoItems.length" class="badge bg-success ms-1">{{ carritoItems.length }}</span>
            </button>
            <div class="carrito-sticky__actions">
              <router-link to="/ordenar" class="btn btn-success btn-sm">Ordenar</router-link>
              <button @click="clearCarrito()" class="btn btn-warning btn-sm">Vaciar</button>
            </div>
          </div>

          <transition name="detalle-slide">
            <div v-if="mostrarDetalle" class="carrito-detalle">
              <p v-if="carritoItems.length === 0" class="carrito-detalle__vacio">El carrito está vacío</p>
              <ul v-else class="carrito-detalle__lista">
                <li v-for="item in carritoItems" :key="item.product" class="carrito-detalle__item">
                  <span class="carrito-detalle__qty">{{ item.quantity }}x</span>
                  <span class="carrito-detalle__nombre">{{ item.product }}</span>
                  <span class="carrito-detalle__subtotal">${{ item.total }}</span>
                </li>
              </ul>
            </div>
          </transition>
        </div>

        <div class="row color-fondo-06">
          <div class="container contenido-menu text-center pt-5">
            <h1>Menú</h1>
            <h5 style="font-style: italic;">"Vive al estilo Chetumal probando las carnitas al estilo Michoacán"</h5>

            <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-4 gy-md-5 mt-2 justify-content-center">
              <div class="col" v-for="item in products" v-bind:key="item.name" style="margin-bottom: 1.5rem">
                <div class="card h-100 product-card">
                  <img :src="item.img" class="card-img-top product-img" :alt="item.name">
                  <div class="card-body d-flex flex-column">
                    <h5 class="card-title">{{ item.name }}</h5>
                    <p class="card-text text-muted flex-grow-1">{{ item.description }}</p>
                    <p class="card-price fw-bold">${{ item.price }}</p>

                    <div class="card-actions">
                      <div v-show="getQuantity(item) > 0" class="d-flex align-items-center justify-content-center gap-2 w-100 mb-2">
                        <button class="btn btn-outline-secondary btn-sm" @click="removeToCount(item)">−</button>
                        <input
                          :value="getQuantity(item)"
                          v-on:change="editQuantity($event, item)"
                          class="form-control input-quantity text-center"
                        >
                        <button class="btn btn-outline-secondary btn-sm" @click="addToCount(item)">+</button>
                      </div>
                      <button class="btn btn-success w-100" @click="addToCount(item)">
                        Agregar al carrito
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-5 pb-4">
              <h3 class="text-white">Total: ${{ total }}</h3>
              <div class="d-flex justify-content-center gap-3 mt-3">
                <router-link to="/ordenar" class="btn btn-success px-4">Ordenar</router-link>
                <button @click="clearCarrito()" class="btn btn-warning px-4">Vaciar carrito</button>
              </div>
              <p class="mt-3 text-white-50">Todos los precios son dados en Moneda Nacional Mexicana</p>
            </div>
          </div>
          <div class="fondo-menu"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.carrito-sticky {
  position: sticky;
  top: 0;
  z-index: 200;
  background: rgba(30, 30, 30, 0.97);
  backdrop-filter: blur(6px);
  border-bottom: 2px solid #2c7a2c;
}

@media (min-width: 992px) {
  .carrito-sticky {
    max-width: 960px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 0 0 8px 8px;
  }
}

@media (min-width: 1200px) {
  .carrito-sticky {
    max-width: 1140px;
  }
}

@media (min-width: 1400px) {
  .carrito-sticky {
    max-width: 1320px;
  }
}
.carrito-sticky__bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.6rem 0.75rem;
}
.carrito-sticky__label {
  color: #aaa;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.carrito-sticky__total {
  color: #fff;
  font-size: 1.2rem;
  font-weight: bold;
  flex: 1;
}
.carrito-sticky__actions {
  display: flex;
  gap: 0.5rem;
  width: 100%;
}
.carrito-sticky__actions .btn {
  flex: 1;
}

.carrito-detalle {
  padding: 0.5rem 1rem 0.75rem;
  border-top: 1px solid rgba(255,255,255,0.1);
}
.carrito-detalle__vacio {
  color: #aaa;
  font-size: 0.9rem;
  margin: 0;
}
.carrito-detalle__lista {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}
.carrito-detalle__item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #fff;
  margin-bottom: 1rem;
}
.carrito-detalle__qty {
  color: #6ee06e;
  font-weight: bold;
  min-width: 2rem;
}
.carrito-detalle__nombre {
  flex: 1;
}
.carrito-detalle__subtotal {
  color: #aaa;
}

.detalle-slide-enter-active,
.detalle-slide-leave-active {
  transition: max-height 0.25s ease, opacity 0.25s ease;
  overflow: hidden;
  max-height: 300px;
}
.detalle-slide-enter-from,
.detalle-slide-leave-to {
  max-height: 0;
  opacity: 0;
}

.product-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s;
  margin-bottom: 1.5rem;
}
.product-card:hover {
  transform: translateY(-4px);
}
.product-img {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  object-position: center center;
  border-radius: 12px 12px 0 0;
  display: block;
}
.card-price {
  font-size: 1.2rem;
  color: #2c7a2c;
}
.card-actions {
  display: flex;
  align-items: center;
  min-height: 40px;
  width: 100%;
}
.input-quantity {
  width: 48px;
  padding: 2px 4px;
}
</style>
<script>




export default {
  name: 'MenuProducts',
  props: {
  
  },
  data() {

         return {
            mostrarDetalle: false,
            total: this.getTotalCarrito(),
            carrito: this.getCarrito(),
            products : [
              {
                price: 380.0,
                name: "Kg carnitas",
                description : "1 Kg, con 30 tortillas",
                img: require('@/assets/img/kilo.webp')
              },
              {
                price: 285.0,
                name: "3/4 kg de carnitas",
                description : "3/4 kg, con 25 tortillas",
                img: require('@/assets/img/tres_cuartos.webp')
              },
              {
                price: 190.0,
                name: "1/2 kg de carnitas",
                description : "1/2 kg, con 15 tortillas",
                img: require('@/assets/img/medio.webp')
              },
              {
                price: 95.0,
                name: "1/4 kg de carnitas",
                description : "1/4 kg, con 8 tortillas",
                img: require('@/assets/img/cuarto.jpg')
              },
              {
                price: 25.0,
                name: "Tacos",
                description : "Tacos",
                img: require('@/assets/img/taco.webp')
              },
              {
                price: 30.0,
                name: "Refresco",
                description : "Refresco",
                img: require('@/assets/img/refresco.webp')
              },
              {
                price: 15.0,
                name: "Orden de tortilla extra",
                description : "Orden de tortilla",
                img: require('@/assets/img/tortilla.webp')
              },
              {
                price: 15.0,
                name: "salsa extra Verde",
                description : "Salsa Verde de chiles habaneros, tomate verde y cebolla ",
                img: require('@/assets/img/salsas.webp')
              },
                {
                price: 15.0,
                name: "salsa extra tipo Guacamole",
                description : "Salsa verde, a base  de aguacate y cilantro molidos",
                img: require('@/assets/img/salsas.webp')
              },
                {
                price: 15.0,
                name: "salsa extra Pico de gallo",
                description : "Salsa Pico de gallo, cebolla,tomate y chile serrano picados",
                img: require('@/assets/img/salsas.webp')
              },
                {
                price: 15.0,
                name: "salsa extra Roja",
                description : "salsa extra Roja tatemada",
                img: require('@/assets/img/salsas.webp')
              },

            ]
         }
      },
 
  computed: {
    carritoItems() {
      return Object.values(this.carrito);
    }
  },

  methods:{

    clearCarrito(){
      this.carrito = {};
      this.total =0;
      localStorage.setItem('carrito',JSON.stringify({}));
      localStorage.setItem('total_carrito',0);
    },
    getTotalCarrito(){

      let totalCarrito =  localStorage.getItem('total_carrito');

      if(totalCarrito == null){
        totalCarrito  = 0;
      }
      else if(isNaN(totalCarrito) === true)
      {
        totalCarrito  = 0;
  
      }

      
      return  parseInt(totalCarrito)
    },

    getCarrito(){
      let carrito = localStorage.getItem('carrito');
      if(carrito == undefined || carrito == null){
        carrito =  '{}';
      }
      return JSON.parse(carrito);
    },
    saveCarrito(){
        localStorage.setItem('carrito',JSON.stringify(this.carrito));
        localStorage.setItem('total_carrito',this.total);
    },
    editQuantity: function(event,product){

        const new_quantity = event.srcElement.value;

        if (new_quantity == 0){
          delete this.carrito[product.name];
        }
        else{
          this.carrito[product.name]  = {
            quantity : new_quantity,
            product: product.name,
            price: product.price,
            total: new_quantity * product.price
          }

        }
        

        this.calculateTotal();
      
    },
    getQuantity : function(product){
     
      
     
      if(product.name in this.carrito ){
        let item = this.carrito[product.name]
        return item.quantity
        
      }
      else{
        return 0
      }
    },

    removeToCount: function(product){

      
      var item  = this.carrito[product.name]
      let update_quantity = 0
        if(item === undefined)
        {
          console.log()
        }
        else{

          if(item.quantity > 0 ) {
               update_quantity = item.quantity - 1;
          
          }
          else {
             update_quantity = 0;
             
           
      
          }

          this.carrito[product.name] = {
            quantity : update_quantity,
            product: product.name,
            price: product.price,
            total: product.price * update_quantity

          }
          
          if (update_quantity == 0)
          {
            delete this.carrito[product.name];
          }

          
        }
       this.calculateTotal()

    },
    calculateTotal:function(){
      let total = 0;
        Object.keys(this.carrito).forEach(element => {
          
          total = total + this.carrito[element].total;
        })

        this.total =  total;
      this.saveCarrito();
    },
    addToCount: function(product){
      
        var item  = this.carrito[product.name]
        if(item === undefined)
        {
          this.carrito[product.name]  = {
            quantity : 1,
            product: product.name,
            price: product.price,
            total: 1 * product.price
          }
        }
        else{
          const update_quantity = item.quantity +1;
          this.carrito[product.name] = {
            quantity : update_quantity,
            product: product.name,
            price: product.price,
            total: product.price * update_quantity

          }
        }
        this.calculateTotal();
    },
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
